<template>
  <div id="app">
    <!-- <component :is="currentHeader" /> -->
    <AppHeader />
    <main>
      <router-view />
    </main>
    <AppFooter />
    <!-- Other components or router-view -->
  </div>
</template>

<script>
import AppHeader from "./components/Navbar.vue";
import AppFooter from "./components/AppFooter.vue";
//import more components here

export default {
  name: "App",
  components: {
    AppHeader,
    AppFooter,
    //import more components here
  },
};
</script>

<style src="./assets/css/styles.css"></style>
